/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  BLSSignatureAggregator,
  BLSSignatureAggregatorInterface,
} from "../../../../contracts/samples/bls/BLSSignatureAggregator";

const _abi = [
  {
    inputs: [],
    name: "BLS_DOMAIN",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "N",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IEntryPoint",
        name: "entryPoint",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "delay",
        type: "uint32",
      },
    ],
    name: "addStake",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation[]",
        name: "userOps",
        type: "tuple[]",
      },
    ],
    name: "aggregateSignatures",
    outputs: [
      {
        internalType: "bytes",
        name: "aggregatedSignature",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "getTrailingPublicKey",
    outputs: [
      {
        internalType: "uint256[4]",
        name: "publicKey",
        type: "uint256[4]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
    ],
    name: "getUserOpHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
    ],
    name: "getUserOpPublicKey",
    outputs: [
      {
        internalType: "uint256[4]",
        name: "publicKey",
        type: "uint256[4]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
    ],
    name: "userOpToMessage",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "",
        type: "uint256[2]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation[]",
        name: "userOps",
        type: "tuple[]",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "validateSignatures",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
    ],
    name: "validateUserOpSignature",
    outputs: [
      {
        internalType: "bytes",
        name: "sigForUserOp",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561001057600080fd5b50611c6f806100206000396000f3fe6080604052600436106100b05760003560e01c806364c530cd11610069578063b7620eb41161004e578063b7620eb4146101d8578063c9e525df146101f8578063e3563a4f1461022c57600080fd5b806364c530cd14610198578063a6193531146101b857600080fd5b8063408644311161009a5780634086443114610129578063451711591461015657806357f09b721461016b57600080fd5b80629d9250146100b5578063275e2d79146100fc575b600080fd5b3480156100c157600080fd5b506100e97fd84c4373167c517e9ccd66803f86d8a4f49e7e1315a7a73b516affea7428f82b81565b6040519081526020015b60405180910390f35b34801561010857600080fd5b5061011c610117366004611296565b61024c565b6040516100f39190611343565b34801561013557600080fd5b506101496101443660046115c0565b6103b4565b6040516100f391906115f5565b610169610164366004611626565b6103e2565b005b34801561017757600080fd5b5061018b6101863660046115c0565b61046d565b6040516100f39190611668565b3480156101a457600080fd5b5061011c6101b3366004611690565b61050e565b3480156101c457600080fd5b506100e96101d33660046115c0565b610676565b3480156101e457600080fd5b5061018b6101f33660046116cc565b610691565b34801561020457600080fd5b506100e97f30644e72e131a029b85045b68181585d97816a916871ca8d3c208c16d87cfd4781565b34801561023857600080fd5b50610169610247366004611701565b610789565b606060008267ffffffffffffffff81111561026957610269611356565b6040519080825280602002602001820160405280156102ae57816020015b60408051808201909152600080825260208201528152602001906001900390816102875790505b50905060005b815181101561034b576000808686848181106102d2576102d2611798565b90506020028101906102e491906117c7565b6102f390610140810190611805565b810190610300919061186a565b9150915060405180604001604052808381526020018281525084848151811061032b5761032b611798565b602002602001018190525050508080610343906118bb565b9150506102b4565b506000610378827f30644e72e131a029b85045b68181585d97816a916871ca8d3c208c16d87cfd47610a71565b805160208083015160405193945061039b93909101918252602082015260400190565b6040516020818303038152906040529250505092915050565b6103bc61120e565b60006103cf6103ca8461046d565b610b5c565b90506103db8382610b8c565b9392505050565b6040517f0396cb6000000000000000000000000000000000000000000000000000000000815263ffffffff8216600482015273ffffffffffffffffffffffffffffffffffffffff831690630396cb609034906024016000604051808303818588803b15801561045057600080fd5b505af1158015610464573d6000803e3d6000fd5b50505050505050565b61047561122c565b60408201518051156104915761048a81610691565b9150610508565b826000015173ffffffffffffffffffffffffffffffffffffffff1663e02afbae61c3506040518263ffffffff1660e01b81526004016080604051808303818786fa1580156104e3573d6000803e3d6000fd5b50505050506040513d601f19601f820116820180604052508101906103db91906118f3565b50919050565b60606000610520610140840184611805565b81019061052d9190611966565b9050600061053d610186856119c6565b9050600061055b61054d866119c6565b61055684610b5c565b610b8c565b6040517febbdac9100000000000000000000000000000000000000000000000000000000815290915073__$b745eded4b1aee1100521038d570dd85f1$__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__$b745eded4b1aee1100521038d570dd85f1$__906391413763906109c090879086908690600401611a6f565b602060405180830381865af41580156109dd573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a019190611a4d565b610a67576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601e60248201527f424c533a2076616c69646174655369676e617475726573206661696c656400006044820152606401610655565b5050505050505050565b6040805180820190915260008082526020820152600083600081518110610a9a57610a9a611798565b6020026020010151600001519050600084600081518110610abd57610abd611798565b602090810291909101810151015190506001805b8651811015610b3d57610b248484848a8581518110610af257610af2611798565b6020026020010151600001518b8681518110610b1057610b10611798565b60200260200101516020015160018c610cad565b9195509350915080610b35816118bb565b915050610ad1565b50610b4a83838388610ffa565b90855260208501525091949350505050565b600081604051602001610b6f9190611668565b604051602081830303815290604052805190602001209050919050565b610b9461120e565b6000610ba08484610c64565b905073__$b745eded4b1aee1100521038d570dd85f1$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";

type BLSSignatureAggregatorConstructorParams =
  | [
      linkLibraryAddresses: BLSSignatureAggregatorLibraryAddresses,
      signer?: Signer
    ]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BLSSignatureAggregatorConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class BLSSignatureAggregator__factory extends ContractFactory {
  constructor(...args: BLSSignatureAggregatorConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        BLSSignatureAggregator__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
  }

  static linkBytecode(
    linkLibraryAddresses: BLSSignatureAggregatorLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$b745eded4b1aee1100521038d570dd85f1\\$__", "g"),
      linkLibraryAddresses["contracts/samples/bls/lib/BLSOpen.sol:BLSOpen"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<BLSSignatureAggregator> {
    return super.deploy(overrides || {}) as Promise<BLSSignatureAggregator>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): BLSSignatureAggregator {
    return super.attach(address) as BLSSignatureAggregator;
  }
  override connect(signer: Signer): BLSSignatureAggregator__factory {
    return super.connect(signer) as BLSSignatureAggregator__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BLSSignatureAggregatorInterface {
    return new utils.Interface(_abi) as BLSSignatureAggregatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BLSSignatureAggregator {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as BLSSignatureAggregator;
  }
}

export interface BLSSignatureAggregatorLibraryAddresses {
  ["contracts/samples/bls/lib/BLSOpen.sol:BLSOpen"]: string;
}
